import React from 'react';

import {Image} from 'primereact/image'

import '../../news-pages.css'
import Parse from 'html-react-parser'

import OwlCarousel from 'react-owl-carousel'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'


const Page = () => {

    const imgs = [];
    imgs.push({
        imageSrc: './news/IRD visiting AMS_250618/cover.jpg',
        alt: 'cover',
        title: 'cover',
        thumbnailImageSrc: './news/IRD visiting AMS_250618/cover.jpg'
    })
    for (let i = 1; i<=20; i++){
        imgs.push({
            imageSrc: `./news/IRD visiting AMS_250618/pic${i}.jpg`,
            alt: `pic${i}`,
            title: `pic${i}`,
            thumbnailImageSrc: `./news/IRD visiting AMS_250618/pic${i}.jpg`
        });
    }

    const detail = 
        {
            id:1,
            ini:'The visit of IRD delegation to the Faculty of Associated Medical Sciences, Chiang Mai University',
            href:'',
            element:'',
            topic:'',
            inform: `On June 18, 2025, a high-level delegation from the Institut de Recherche pour le Développement (IRD), including 
            <ul>
                <li><b>Mr. Gilles Pécassou:</b> Deputy Director General</li>
                <li><b>Mr. Vincent Drapeau:</b> Asia and Pacific Project Manager</li>
                <li><b>Mr. Xavier Mari:</b> IRD Representative in Bangkok</li>
            </ul>
            visited Chiang Mai University’s Office of the President and the Faculty of Associated Medical Sciences (AMS-CMU). The session featured key presentations on 
            <ul>
                <li><b>AMS–IRD collaboration</b> by Dr. Ratchada Cresessey</li>
                <li><b>The IJL PRESTO project</b> by Dr. Nicole Ngo-Giang-Huong</li>
                <li><b>The VERDI SARS-CoV-2 household transmission study</b> by Dr. Woottichai Khamduang</li>
                <li><b>The SIREN study on zoonotic viruses in Chiang Mai province</b> by Premmarin Inmonthain</li>
                <li><b>Surveillance of Streptococcus suis in pigs</b> by Dr. Macro J. Haenssgen</li>
                <li><b>Capacity strengthening in <i>Bio-informatics</i></b> by Mathis Arnal</li>
                <li><b>Social Sciencecs in One Health</b> by Dr. Woottichai Khamduang</li>
            </ul>
            The meeting showcased ongoing and future collaborative efforts in social sciences, environment, public health, bioinformatics, and One Health research.`,
            link1: 'https://www.ams.cmu.ac.th/site/article?id=4443'
        
        }
    
        const handleLink1 = () =>{
            window.open(detail.link1, '_blank', 'noreferrer')
        }


    return (
        <div className='elements containers'>
            <div className="img-slicer">
                <OwlCarousel
                    className='owl-theme'
                    loop={true}
                    margin={10}
                    lazyLoad={true}
                    nav
                    items={1}
                    autoplay={true}
                    autoplayTimeout={3000}
                    autoplayHoverPause={true}
                    smartSpeed={1000}
                >
                    {imgs.map((imgs,index)=>(
                        <div className="item" key={index}><img src={imgs.imageSrc} alt="item" /></div>
                    ))}
                </OwlCarousel>
            </div>
            <div className="text">
                <h1>{detail.ini}</h1>
                <h2>{Parse(detail.topic)}</h2>
                <p>{Parse(detail.inform)}</p>
               <div className="btn">
                     <h2>MORE INFORMATION</h2>
                     <button onClick={handleLink1}>{detail.link1}</button>
                </div>
            </div>
            <div className="gallery">
                {imgs.map((img) =>(
                    <div className="img">
                        <Image src={img.imageSrc} alt='img' width='200' preview></Image>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Page;
